import { Injectable } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SharedEnvironmentService {
  protected baseUrlProperties = ['appUrl', 'urlBase'];

  constructor(private location: PlatformLocation) {}

  /**
   * Returns the variable value.
   * */
  public get(name: string): any {
    if (!this.baseUrlProperties.some((v) => v === name)) return environment[name];
    return this.addBaseUrl(environment[name]);
  }

  protected addBaseUrl(url: string): string {
    if (new RegExp('^(https?:\\/\\/)').test(url)) return url;
    const base = new URL(this.location?.href)?.origin || '';
    if (!url?.length) return base;
    return [base, url].join('/');
  }
}
